import { render } from "react-dom";
import * as React from "react";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import "Styles/Pages/portal-banner.scss";
import { Banner } from "features/EnterprisePortal/Components/Banner";
import { LayoutContextProvider } from "Components/LayoutContext";


const hiwRoot = document.getElementById("portal-banner-root")!;
const accountId = hiwRoot.dataset["accountId"]!;

if (accountId) {
   render(<Provider store={LSStore.instance}>
      <LayoutContextProvider>
         <CookiesProvider>
            <Banner accountId={accountId} fixed />
         </CookiesProvider>
      </LayoutContextProvider>
   </Provider>, hiwRoot);
}


